import { useQuery } from "@tanstack/react-query";
import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "../../api/classifier";
import type { DiagnosisEvidenceRow } from "./types";

interface DiagnosisEvidenceResponse {
  evidence: DiagnosisEvidenceRow[];
}

async function fetchDiagnosisEvidence(classificationResultId: string): Promise<DiagnosisEvidenceRow[]> {
  const url = `${QA_API_DOMAIN}/diagnosis-evidence/${classificationResultId}/evidence`;
  const response = await fetchWithSupabaseAuth(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch diagnosis evidence: ${response.status}`);
  }

  const data: DiagnosisEvidenceResponse = await response.json();
  return data.evidence;
}

export function useDiagnosisEvidence(classificationResultId: string | undefined) {
  return useQuery({
    queryKey: ["diagnosis-evidence", classificationResultId],
    queryFn: () => fetchDiagnosisEvidence(classificationResultId!),
    enabled: !!classificationResultId,
  });
}
